module.exports = __webpack_public_path__ + "img/p_17_s.61232c40.png";